import * as React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface IBookIconProps extends IconPropsType {}

const BookIcon = ({
  size = 16,
  fill = '#41435A',
  ...props
}: IBookIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5 2V12C13.5 12.1326 13.4473 12.2598 13.3536 12.3536C13.2598 12.4473 13.1326 12.5 13 12.5H4.5C4.23478 12.5 3.98043 12.6054 3.79289 12.7929C3.60536 12.9804 3.5 13.2348 3.5 13.5H12C12.1326 13.5 12.2598 13.5527 12.3536 13.6464C12.4473 13.7402 12.5 13.8674 12.5 14C12.5 14.1326 12.4473 14.2598 12.3536 14.3536C12.2598 14.4473 12.1326 14.5 12 14.5H3C2.86739 14.5 2.74021 14.4473 2.64645 14.3536C2.55268 14.2598 2.5 14.1326 2.5 14V3.5C2.5 2.96957 2.71071 2.46086 3.08579 2.08579C3.46086 1.71071 3.96957 1.5 4.5 1.5H13C13.1326 1.5 13.2598 1.55268 13.3536 1.64645C13.4473 1.74021 13.5 1.86739 13.5 2Z"
      fill={fill}
    />
  </svg>
);

export default BookIcon;
